import React from 'react';
import { Typography, Image, Button } from 'antd';
import { CheckCircleOutlined, GlobalOutlined } from '@ant-design/icons';
import styles from './takeAction.module.scss';
import { useTranslation } from 'react-i18next';

const { Title, Text } = Typography;

const renderIcon = (icon: string) => {
  if (icon.startsWith('data:') || icon.startsWith('blob:') || icon.includes('resources/images/icons')) {
    return <img src={icon} alt='icon' className={styles.statImage} />;
  }

  switch (icon) {
    case 'CheckCircleOutlined':
      return <CheckCircleOutlined className={styles.statIcon} />;
    case 'GlobalOutlined':
      return <GlobalOutlined className={styles.statIcon} />;
    default:
      return null;
  }
};

const TakeAction: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.climateTradeContainer}>
      <div className={styles.statSection}>
        <Image src='/images/carbon-credit-bg.jpg' alt='impact' className={styles.statImage} />
      </div>
      <div className={styles.textSection}>
        <Title level={3} className={styles.climateTradeTitle}>
          <h1>{t('whyCarbonCredit')}</h1> {/* ✅ Translate Section Heading */}
        </Title>
        <Text className={styles.climateTradeText}>{t('whyCarbonCredit')}</Text> {/* ✅ Translate Content */}
        <Text className={styles.climateTradeText}>{t('whyCarbonCreditContent')}</Text> {/* ✅ Translate Content */}
        {/* <Button>Our Carbon manifesto</Button> */}
      </div>
    </div>
  );
};

export default TakeAction;
